import { buildHost } from "@/features/chat/chatHost";
import { ChatsListPage } from "@/features/chat/history/ChatsListPage";

/** `/build/with-ai/history`: the user's build chats. */
export function BuildHistoryPage() {
  return <ChatsListPage host={buildHost} />;
}
